import {ReadNewsItemsStore} from "../read-items/ReadNewsItemsStore";
import {NewsItemService} from "../../service/items/NewsItemService";
import {NewsStore} from "./NewsStore";
import {NewsHeadlineStreamStore} from "../stream/NewsHeadlineStreamStore";
import {NewsSessionIdStore} from "../news-id/NewsSessionIdStore";

export class NewsStoreFactory {

    public static readonly id = "newsStoreFactory";

    /** @ngInject */
    public constructor(private readonly newsItemService: NewsItemService,
                       private readonly readNewsItemsStore: ReadNewsItemsStore,
                       private readonly newsHeadlineStreamStore: NewsHeadlineStreamStore,
                       private readonly newsSessionIdStore: NewsSessionIdStore) {
    }

    public create(): NewsStore {
        return new NewsStore(this.newsItemService,
                             this.readNewsItemsStore,
                             this.newsHeadlineStreamStore,
                             this.newsSessionIdStore);
    }
}
